import { Temporal } from "@js-temporal/polyfill";

//#region src/common/temporal.ts
/**
* Central import point for Temporal API
* This abstraction allows us to transparently switch between polyfill and native implementation
*
* When native Temporal support is widely available:
* 1. Remove the polyfill import
* 2. Export globalThis.Temporal directly
* 3. Remove @js-temporal/polyfill from package.json
*
* All consuming code remains unchanged.
*/
/**
* Access the Temporal API, preferring native implementation when available
*/
const Temporal$1 = typeof globalThis.Temporal !== "undefined" ? globalThis.Temporal : Temporal;

//#endregion
export { Temporal$1 as Temporal };